module.exports = __webpack_public_path__ + "static/img/1.c335f4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/1.png
// module id = hADo
// module chunks = 1